import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAppId } from "../context/AppIdContext";
import '../style/boothPramukh.css'
import Header from '../component/header';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const PollingLocationWiseVoters = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const { appId, language } = useAppId();
    const navigate = useNavigate();

    const lang = language || 'en';

    // Translation dictionary
    const t = {
        en: {
            // Page titles
            title: "Polling Locations Wise Voters",
            subtitle: "Overview of voter distribution across stations.",
            
            // Search
            searchPlaceholder: "Search Polling Location...",
            
            // Table headers
            pollingLocation: "Polling Location",
            voterCount: "Voter Count",
            
            // Messages
            loading: "Loading Data...",
            unknownLocation: "Unknown Location",
            noRecordsFound: "No records found matching",
            noDataAvailable: "No data available",
            
            // Status
            active: "ACTIVE",
            notActive: "NOT ACTIVE",
            
            // Errors
            error: "Error",
            failed: "Failed: "
        },
        
        hi: {
            // Page titles
            title: "मतदान स्थल वार मतदाता",
            subtitle: "स्टेशनों पर मतदाता वितरण का अवलोकन।",
            
            // Search
            searchPlaceholder: "मतदान स्थल खोजें...",
            
            // Table headers
            pollingLocation: "मतदान स्थल",
            voterCount: "मतदाता संख्या",
            
            // Messages
            loading: "डेटा लोड हो रहा है...",
            unknownLocation: "अज्ञात स्थान",
            noRecordsFound: "कोई रिकॉर्ड नहीं मिला",
            noDataAvailable: "कोई डेटा उपलब्ध नहीं है",
            
            // Status
            active: "सक्रिय",
            notActive: "निष्क्रिय",
            
            // Errors
            error: "त्रुटि",
            failed: "विफल: "
        },
        
        gu: {
            // Page titles
            title: "મતદાન સ્થળ વાઈઝ મતદારો",
            subtitle: "સ્ટેશનો પર મતદાર વિતરણની ઝાંખી.",
            
            // Search
            searchPlaceholder: "મતદાન સ્થળ શોધો...",
            
            // Table headers
            pollingLocation: "મતદાન સ્થળ",
            voterCount: "મતદાર સંખ્યા",
            
            // Messages
            loading: "ડેટા લોડ થઈ રહ્યો છે...",
            unknownLocation: "અજ્ઞાત સ્થળ",
            noRecordsFound: "કોઈ રેકોર્ડ મળ્યો નથી",
            noDataAvailable: "કોઈ ડેટા ઉપલબ્ધ નથી",
            
            // Status
            active: "સક્રિય",
            notActive: "નિષ્ક્રિય",
            
            // Errors
            error: "ભૂલ",
            failed: "નિષ્ફળ: "
        }
    };

    const txt = t[lang];

    useEffect(() => {
        if (appId) {
            fetchUsers();
        } else {
            navigate("/");
        }
    }, [appId, navigate]);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${BASE_URL}/api/dis_all_polling_location`,
                { app_id: appId }
            );

            if (response.data.success && response.data.data && response.data.data.result) {
                setUsers(response.data.data.result);
            } else {
                setUsers([]);
            }
        } catch (err) {
            console.error("API Error:", err);
            setUsers([]);
        } finally {
            setLoading(false);
        }
    };

    // Filter Logic
    const filteredUsers = users.filter((user) => {
        if (!searchTerm) return true;
        const term = searchTerm.toLowerCase();
        return String(user.eng_polling_location || "").toLowerCase().includes(term);
    });

    const handleRowClick = (pollingLocation) => {
        navigate('/polling_location_wisesearch', {
            state: { autoSearchLocation: pollingLocation }
        });
    };

    if (loading) {
        return (
            <div className="loader-wrapper">
                <div className="spinner"></div>
                <p className="loader-text">{txt.loading}</p>
                <style jsx>{`
                    .loader-wrapper {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        min-height: 60vh;
                        width: 100%;
                    }
                    .spinner {
                        width: 50px;
                        height: 50px;
                        border: 4px solid #E5E7EB;
                        border-top: 4px solid #2563EB;
                        border-radius: 50%;
                        animation: spin 1s linear infinite;
                        margin-bottom: 16px;
                        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                    }
                    .loader-text {
                        color: #6B7280;
                        font-weight: 500;
                        font-size: 1.1rem;
                        animation: pulse 1.5s ease-in-out infinite;
                    }
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    @keyframes pulse {
                        0%, 100% { opacity: 1; }
                        50% { opacity: 0.5; }
                    }
                `}</style>
            </div>
        );
    }

    return (
        <div className='app-container p-4' style={{ minHeight: '100vh' }}>
            
            {/* 1. Integrated Header Component */}
            <Header 
                title={txt.title}
            />

            {/* 2. Professional Filter Container (Always Visible) */}
            <div className="filter-container-modern">
                <div className="search-wrapper-modern">
                    <svg className="search-icon-modern" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <input
                        type="text"
                        className="search-input-modern"
                        placeholder={txt.searchPlaceholder}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                {/* --- Count Display --- */}
                <div className="count-display-modern slide-up-element">
                    <span className="count-label">Total :</span>
                    <span className="count-number">{filteredUsers.length}</span>
                </div>
            </div>

            {/* --- Enhanced Table View --- */}
            <div className="table-container" style={{
                background: '#fff',
                borderRadius: '16px',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                overflow: 'hidden',
                border: '1px solid #f3f4f6'
            }}>
                <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <table className="table" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0' }}>
                        <thead style={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 10,
                            backgroundColor: '#f8fafc',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                        }}>
                            <tr>
                                <th style={{
                                    padding: '16px 24px',
                                    textAlign: 'left',
                                    color: '#64748b',
                                    fontSize: '12px',
                                    fontWeight: '700',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em',
                                    borderBottom: '1px solid #e2e8f0'
                                }}>
                                    {txt.pollingLocation}
                                </th>
                                <th style={{
                                    padding: '16px 24px',
                                    textAlign: 'center',
                                    color: '#64748b',
                                    fontSize: '12px',
                                    fontWeight: '700',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em',
                                    width: '180px',
                                    borderBottom: '1px solid #e2e8f0'
                                }}>
                                    {txt.voterCount}
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ backgroundColor: 'white' }}>
                            {filteredUsers.length > 0 ? (
                                filteredUsers.map((user, index) => (
                                    <tr
                                        key={user.id || index}
                                        onClick={() => handleRowClick(user.eng_polling_location)}
                                        style={{
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            borderBottom: '1px solid #f1f5f9'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#eff6ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        <td style={{
                                            padding: '20px 24px',
                                            color: '#334155',
                                            fontSize: '15px',
                                            fontWeight: '500',
                                            borderBottom: '1px solid #f1f5f9'
                                        }}>
                                            {user.eng_polling_location || <span style={{ color: '#94a3b8', fontStyle: 'italic' }}>{txt.unknownLocation}</span>}
                                        </td>

                                        <td style={{
                                            padding: '20px 24px',
                                            textAlign: 'center',
                                            borderBottom: '1px solid #f1f5f9'
                                        }}>
                                            <span style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                background: 'linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%)',
                                                color: '#0284c7',
                                                padding: '6px 16px',
                                                borderRadius: '9999px',
                                                fontWeight: '700',
                                                fontSize: '14px',
                                                minWidth: '70px',
                                                boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                                                border: '1px solid #bae6fd'
                                            }}>
                                                {user.total_voter}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2" style={{ padding: '60px 20px', textAlign: 'center' }}>
                                        <div className="no-data-message">
                                            <div className="no-data-icon">📍</div>
                                            <div className="no-data-text">
                                                {searchTerm ? `${txt.noRecordsFound} "${searchTerm}"` : txt.noDataAvailable}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <style jsx>{`
                /* --- PROFESSIONAL FILTER CONTAINER STYLING --- */
                .filter-container-modern {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 24px;
                }
                
                /* --- COUNT DISPLAY --- */
                .count-display-modern {
                    display: inline-flex;
                    align-items: center;
                    background: #eff6ff;
                    padding: 8px 16px;
                    border-radius: 12px;
                    border: 1px solid #bfdbfe;
                    box-shadow: 0 2px 4px rgba(37, 99, 235, 0.05);
                    gap: 8px;
                }
                .count-label {
                    color: #1e40af;
                    font-weight: 600;
                    font-size: 15px;
                }
                .count-number {
                    background: transparent;
                    color: #1d4ed8;
                    font-weight: 800;
                    font-size: 16px;
                }
                .search-wrapper-modern {
                    position: relative;
                    width: 100%;
                    max-width: 450px;
                }
                .search-icon-modern {
                    position: absolute;
                    left: 14px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    width: 20px;
                    height: 20px;
                    pointer-events: none;
                }
                .search-input-modern {
                    width: 100%;
                    padding: 12px 16px 12px 46px;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    font-size: 14px;
                    color: #1e293b;
                    background-color: #ffffff;
                    outline: none;
                    transition: all 0.2s ease;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                }
                .search-input-modern:focus {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
                    background-color: #fff;
                }

                /* No Data Message Styling */
                .no-data-message {
                    text-align: center;
                    padding: 20px;
                }

                .no-data-icon {
                    font-size: 64px;
                    margin-bottom: 16px;
                    opacity: 0.5;
                }

                .no-data-text {
                    font-size: 16px;
                    font-weight: 500;
                    color: #6b7280;
                }

                @media (max-width: 640px) {
                    .filter-container-modern {
                        margin-bottom: 20px;
                    }
                    .search-wrapper-modern {
                        max-width: 100%;
                    }
                    .search-input-modern {
                        padding: 12px 16px 12px 42px;
                        font-size: 14px;
                    }
                    .table-container {
                        border-radius: 12px;
                    }
                    
                    .no-data-icon {
                        font-size: 48px;
                    }
                    
                    .no-data-text {
                        font-size: 14px;
                    }
                }
            `}</style>
        </div>
    );
};

export default PollingLocationWiseVoters;